import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';

const permissionGuard = (route: any, state: any) => inject(PermissionGuard).canActivate(route, state);

export const SurveyRoutes: Route = {
    path: 'survey',
    data: { title: 'survey', breadcrumbSkipNavigation: true },
    children: [
        {
            path: 'contract-survey',
            data: { title: 'contract-survey' },
            children: [
                {
                    path: '',
                    loadComponent: () =>
                        import('./pages/contract-survey/contract-survey.component').then(
                            (m) => m.ContractSurveyComponent
                        ),
                    canActivate: [permissionGuard],
                },
                {
                    path: 'contract-form',
                    loadComponent: () =>
                        import('./pages/survey-form/survey-form.component').then((m) => m.SurveyFormComponent),
                    data: { title: 'contract-survey-form', isBaseline: false },
                },
            ],
        },
        {
            path: 'contract-status',
            loadComponent: () =>
                import('./pages/contract-status/contract-status.component').then((m) => m.ContractStatusComponent),
            data: { title: 'contract-survey-status' },
            canActivate: [permissionGuard],
        },
        {
            path: 'baseline-survey',
            data: { title: 'baseline-survey' },
            children: [
                {
                    path: '',
                    loadComponent: () =>
                        import('./pages/baseline-survey/baseline-survey.component').then(
                            (m) => m.BaselineSurveyComponent
                        ),
                    canActivate: [permissionGuard],
                },
                {
                    path: 'baseline-form',
                    loadComponent: () =>
                        import('./pages/survey-form/survey-form.component').then((m) => m.SurveyFormComponent),
                    data: { title: 'baseline-survey-form', isBaseline: true },
                },
            ],
        },
        {
            path: 'baseline-status',
            loadComponent: () =>
                import('./pages/baseline-status/baseline-status.component').then((m) => m.BaselineStatusComponent),
            data: { title: 'baseline-survey-status' },
            canActivate: [permissionGuard],
        },
        {
            path: 'questions',
            loadComponent: () => import('./pages/questions/questions.component').then((m) => m.QuestionsComponent),
            data: { title: 'survey-questions' },
            // canActivate: [permissionGuard],
        },
    ],
};
